import { Theme } from '@mui/material'
import { css } from '@emotion/react'

export const navButtonStyle = (
  theme: Theme,
  selected: boolean,
  highlight: 'light' | 'dark',
  textLength: number,
) => {
  const hightlightColor = highlight === 'light' ? '#FFFFFF' : '#f8f8f8'
  return css`
    background-color: ${selected ? hightlightColor : 'inherit'};
    box-shadow: ${selected ? '4px 4px 4px 0 rgba(0, 0, 0, 0.05)' : 'none'};
    color: ${selected ? theme.palette.primary.main : theme.palette.secondary[700]};
    font-weight: ${selected ? 700 : 500};
    min-width: 100px;
    white-space: nowrap;
    width: ${textLength * 11}px;

    &:hover {
      background-color: ${selected ? hightlightColor : hightlightColor + '80'};
      box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.05);
    }
  `
}
